<template>
  <div class="select_resourse">
    <el-dialog
      :title="`问卷详情--${poinyterRow.title}`"
      :visible.sync="questionDetailDialog"
      width="80%"
      @closeResourse
    >
      <!-- TODO 导出问卷， 导出统计-->
      <section style="margin-bottom: 10px">
        <el-button type="primary" size="mini" @click="handleWordExport"
          >导出问卷</el-button
        >
        <el-button type="primary" size="mini" @click="handleDetailsTag"
          >查看提交情况</el-button
        >
      </section>
      <section class="statistics">
        该问卷为考核问卷，应交问卷{{
          questionStatisticsHeaderData.should_num
        }}人，已交{{ questionStatisticsHeaderData.ct_num }}人，未交{{
          questionStatisticsHeaderData.should_num -
          questionStatisticsHeaderData.ct_num
        }}人，完成率{{ questionStatisticsHeaderData.num_rate }}%
      </section>
      <!-- 标签页 -->
      <div class="my_tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="问卷统计" name="first">
            <!-- 问卷统计 -->
            <section v-if="total !== 0">
              <!-- 题目列表 -->
              <div
                v-for="(item, index) in questionStatisticsData.subject"
                :key="index"
              >
                <div style="margin: 10px 0" class="answer-title">
                  <!--{{index}}.{{item.title}}？-->
                  <span> {{ index + 1 }}. </span>
                  <span v-html="item.title"></span>
                  <span
                    v-if="item.type == 1 && item.answer_type == 1"
                    key="type-1-one"
                    >【单选】</span
                  >
                  <span
                    v-else-if="item.type == 1 && item.answer_type == 2"
                    key="type-2-one"
                    >【多选】</span
                  >
                  <span v-else-if="item.type == 2" key="type-3-one"
                    >【填空】</span
                  >
                  <span v-if="item.object_join_name" key="type-4-one"
                    >【评价：{{ item.object_join_name }}】</span
                  >
                </div>
                <div>
                  <div v-if="item.type === 1" key="option-1">
                    <el-table
                      :data="item.option"
                      border
                      size="mini"
                      show-summary
                      sum-text="本次有效填写人数"
                    >
                      <el-table-column
                        label="选项"
                        align="center"
                        prop="content"
                      />
                      <el-table-column
                        label="小计"
                        align="center"
                        prop="answer_num"
                      />
                      <el-table-column label="比例" align="center">
                        <template slot-scope="scope">
                          <el-progress
                            :percentage="Number.parseInt(scope.row.answer_rate)"
                          ></el-progress>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-else-if="item.type === 2" key="answer-1">
                    <el-table :data="item.answer_text" border size="mini">
                      <el-table-column
                        label="序号"
                        align="center"
                        type="index"
                      />
                      <el-table-column
                        label="提出学员入驻平台时长"
                        align="center"
                        prop="settled_date"
                      >
                        <template slot-scope="scope">
                          {{ scope.row.settled_date }}天
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="提交内容"
                        align="center"
                        prop="answer"
                      />
                    </el-table>
                  </div>
                </div>
              </div>
            </section>
            <Empty v-else></Empty>
          </el-tab-pane>
          <el-tab-pane label="答题明细" name="second">
            <!-- 答题明细 -->
            <section>
              <el-table
                :data="answerDetailsList"
                :header-cell-style="{
                  background: '#F0F0F0',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#333',
                }"
              >
                <span
                  v-for="(aitem, aindex) in answerDetailsHeader"
                  :key="aindex"
                >
                  <el-table-column
                    :label="aitem.c_name"
                    align="center"
                    :prop="aitem.name"
                    show-overflow-tooltip
                  />
                </span>
                <el-table-column
                  label="操作"
                  align="center"
                  width="1px"
                ></el-table-column>
              </el-table>
            </section>
          </el-tab-pane>
        </el-tabs>
        <el-button
          type="primary"
          v-if="activeName == 'first'"
          size="mini"
          @click="handleExportQuestionnaire"
          class="export_cls"
          >导出统计</el-button
        >
        <div class="export_cls" v-else>
          <el-button type="primary" size="mini" @click="customAdd"
            >自定义表头</el-button
          >
          <el-button type="primary" size="mini" @click="handleExport"
            >导出答题明细</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 自定义表头dialog -->
    <el-dialog
      :title="`自定义表头`"
      :visible.sync="customHeaderDialog"
      width="50%"
      @close="closeCustomHeader"
    >
      <!-- 个人信息显示 -->
      <section class="header-title" v-if="userArr.length > 0">
        个人信息显示
      </section>
      <el-row>
        <el-col
          :span="6"
          v-for="(item, index) in userArr"
          :key="item.id"
          class="mt8"
        >
          <div class="conditions">
            <el-checkbox
              v-model="item.is_show"
              :checked="item.is_show == 1"
              :label="item.c_name"
            ></el-checkbox>
          </div>
        </el-col>
      </el-row>
      <!-- 统计等其他信息展示 -->
      <section class="header-title mt18" v-if="otherArr.length > 0">
        统计等其他信息展示
      </section>
      <el-row>
        <el-col
          :span="6"
          v-for="(item, index) in otherArr"
          :key="item.id"
          class="mt8"
        >
          <div class="conditions">
            <el-checkbox
              v-model="item.is_show"
              :checked="item.is_show == 1"
              :label="item.c_name"
            ></el-checkbox>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
        <el-button @click="cancel" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  QuestionStatistics,
  QuestionStatisticsHeader,
  ExportQuestion,
  AnswerQuestionDetail,
  CustomHeader,
  EditorQuestionHeader,
  ExportAnswerDetail,
  ExportStatistics,
} from "@/api/tearcher";
export default {
  props: {
    // 1在日程安排表格，2在提交详情
    is_who: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      questionDetailDialog: false,
      customHeaderDialog: false,
      activeName: "first",
      questionStatisticsData: {}, //问卷统计
      questionStatisticsHeaderData: {}, //问卷统计头部
      poinyterRow: "", // 当前节点对象
      total: 1, //
      answerDetailsList: [],
      answerDetailsHeader: [],
      userArr: [],
      otherArr: [],
    };
  },
  methods: {
    // 操作dialog
    operationDialog(row) {
    //   this.poinyterRow = row;
    //   this.questionStatisticsFn();
    //   this.questionStatisticsHeaderFn();
    },
    // tabs方法
    handleClick(tab) {
      // console.log(tab);
      if (tab.name == "first") {
        // 问卷统计
      } else {
        // 答题明细
        this.handleAnswerDetails();
      }
    },
    // 答题明细接口
    handleAnswerDetails() {
      AnswerQuestionDetail({ id: this.poinyterRow.id }).then((res) => {
        let response = res.data;
        this.answerDetailsList = response.list;
        this.answerDetailsHeader = response.header;
      });
    },
    // 问卷统计
    questionStatisticsFn() {
      QuestionStatistics({ id: this.poinyterRow.id }).then((res) => {
        this.questionStatisticsData = res.data.questionnaire;
        this.total = this.questionStatisticsData.subject.length;
        console.log(this.total);
      });
    },
    // 问卷统计头部
    questionStatisticsHeaderFn() {
      QuestionStatisticsHeader({ id: this.poinyterRow.id }).then((res) => {
        this.questionStatisticsHeaderData = res.data;
      });
    },
    // 导出问卷
    handleWordExport() {
      if (this.total == 0) {
        this.messageTips("暂无导出数据", "");
        return;
      }
      let zipData = ExportQuestion({ id: this.poinyterRow.id });
      zipData
        .then((res) => {
          if (res.data) {
            // 根路径：window.location.origin
            this.downloadFile(window.location.origin + "/" + res.data);
          } else {
            this.messageTips("暂无导出数据", "error");
          }
        })
        .catch(() => {});
    },
    /** 查看提交情况 */
    handleDetailsTag() {
      if (this.is_who === 2) {
        this.questionDetailDialog = false;
      } else {
        this.$router.push({
          path: "/QuestionCommitDetail",
          query: {
            poinyterId: this.poinyterRow.id,
            title: this.poinyterRow.title,
          },
        });
      }
    },
    /** 导出问卷统计 word */
    handleExportQuestionnaire() {
      console.log(this.total, "322");
      if (this.total == 0) {
        this.messageTips("暂无导出数据", "error");
        return false;
      }
      let zipData = ExportStatistics({ id: this.poinyterRow.id });
      zipData
        .then((res) => {
          console.log(res.data, "330");
          if (res.data) {
            this.downloadFile(window.location.origin + "/" + res.data);
          } else {
            console.log(4234242);
            this.messageTips("暂无导出数据", "error");
          }
        })
        .catch((reason) => {
          // console.log(reason);
        });
    },
    /** 自定义表头 */
    customAdd() {
      CustomHeader().then((res) => {
        this.customHeaderDialog = true;
        this.userArr = res.data.user;
        this.otherArr = res.data.other;
      });
    },
    // 确 定
    submitForm() {
      let postData = [...this.userArr, ...this.otherArr];
      EditorQuestionHeader({ data: postData })
        .then((response) => {
          if (response.error_code === 201) {
            this.messageTips("设置成功", "success");
            this.handleAnswerDetails();
            this.cancel();
          }
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    // 取 消
    cancel() {
      this.customHeaderDialog = false;
    },
    // 窗口关闭
    closeCustomHeader() {
      this.reset();
    },
    // 数组重置
    reset() {
      this.userArr = [];
      this.otherArr = [];
    },
    /** 导出答题明细 */
    handleExport() {
      ExportAnswerDetail({ id: this.poinyterRow.id }).then((res) => {
        saveAs(res, "答题明细.xls");
      });
    },
    createFn() {
     
    },
  },
   created() {
    // this.createFn();
     // 资源id
    //   this.pointerId = this.$route.query.pointerId;
    //   this.title = this.$route.query.title;
    //   this.class_id = this.$route.query.class_id;
    //   this.requestCommonFn();
    //   // 签到详情头部
    //   SignDetailHeader({
    //     id: this.pointerId,
    //   }).then((res) => {
    //     this.statisticsDatas = res.data;
    //   });
    // this.poinyterRow = row;
    //   this.questionStatisticsFn();
    //   this.questionStatisticsHeaderFn();
  },
};
</script>
 
<style lang = "less" scoped>
.select_resourse {
  /* 标题样式 */
  /deep/ .el-dialog__header {
    padding: 15px 0 15px 20px;
    border-bottom: 1px solid#F0F0F0;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 20px;
      bottom: 0;
      width: 30px;
      height: 1px;
      background-color: #ffc61c;
    }

    .el-dialog__title {
      font-size: 22px;
    }
  }
  .statistics {
    font-size: 14px;
    margin: 24px 0;
    color: #303133;
    background-color: #f2f2f2;
    padding: 10px;
  }
  .my_tabs {
    position: relative;
    .export_cls {
      position: absolute;
      right: 0;
      top: 0;
    }
    /deep/.answer-title {
      p {
        display: inline-block;
      }
    }
  }
  .header-title {
    font-size: 14px;
    margin-bottom: 10px;
    color: #303133;
    background-color: #f2f2f2;
    padding: 10px;
  }
}
</style>